var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://cdn.linearicons.com/free/1.0.0/icon-font.min.css"}}),_c('link',{attrs:{"rel":"stylesheet","href":"https://cdn.plyr.io/3.6.12/plyr.css"}}),_c('div',{attrs:{"id":"wrapper"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }